import type { Currency } from "@/entities/currency";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_NAMES } from "@/entities/referential";

export const useReferentialCurrencies = (
  options?: UseReferentialOptions<Currency[]>
) => {
  const { data, ...queryResult } = useReferential<Currency[]>(
    REFERENTIAL_NAMES.CURRENCIES,
    { ...options, persist: true }
  );

  const currencies = data ?? [];

  const defaultCurrency = currencies.find((c) => c.is_default);

  return {
    currencies,
    defaultCurrency,
    ...queryResult,
  };
};

export const useReferentialDefaultCurrency = () => {
  const { defaultCurrency } = useReferentialCurrencies();

  return defaultCurrency?.currency;
};
